module.exports = __webpack_public_path__ + "vue_assets/img/badge_deios_lifetime.60053535.png";